import { Component, OnInit, Input, inject } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { ApiService } from 'src/app/services/api/api.service';
import { ModalController } from '@ionic/angular';
import { ExercisemodalComponent } from '../../components/exercisemodal/exercisemodal.component'
import { VideomodalComponent } from '../../components/videomodal/videomodal.component'
import { InfozonemodalComponent } from '../infozonemodal/infozonemodal.component';

@Component({
    selector: 'app-exerciseitem',
    templateUrl: './exerciseitem.component.html',
    styleUrls: ['./exerciseitem.component.scss'],
    standalone: false
})
export class ExerciseitemComponent implements OnInit {
  @Input() exercise: any;

  private api = inject(ApiService);

  constructor(public modalController:ModalController, public data: DataService) {
  }

  ngOnInit() {
    console.log(" ngOnInit this.exercise.thumb " + this.exercise.id)
  }

  select_(){
    console.log(this.video)
  }

  get video() {
    return this.exercise.video;
  }

  reseter(exercise){
    console.log("reseter");
    // console.log(this.exercise.current.id+'-1');
    // this.exercise = exercise;
    // console.log(this.exercise.current.id+'-2');
    // this.data.pullAppContent(['endpoint']).then(() => {
    //   this.data.pullAppContent(['smodules']);
    // });
  }

  async selectinfozone(){
    let that = this
    const modal = await this.modalController.create({
      component: InfozonemodalComponent,
      animated: true,
      htmlAttributes: { 'aria-label': 'Info: ' + (that.exercise?.infozone?.title || '') },
      componentProps: {
        infozone: that.exercise.infozone,
        basepath: that.api.getMediaBase()
      }
    });

    this.data.setEventsAnalytics('Open infozone ' + this.exercise.infozone_id, 'event', {
      exercise_id: this.exercise.id,
      infozone_id: this.exercise.infozone_id
    });

    return await modal.present();
  }

  async selectvideo(){
    let that = this
    const modal = await this.modalController.create({
      component: VideomodalComponent,
      animated: true,
      cssClass: 'exercise-modal-shell',
      htmlAttributes: { 'aria-label': 'Video: ' + (that.exercise?.video?.title || '') },
      componentProps: {
        video: that.exercise.video,
        basepath: that.api.getMediaBase()
      }
    });

    this.data.setEventsAnalytics('Open video ' + this.exercise.video.title, 'event', {
      exercise_id: this.exercise.id,
      video_id: this.exercise.video.id
    });

    return await modal.present();
  }


  async select(){
    let that = this
    const modal = await this.modalController.create({
      component: ExercisemodalComponent,
      animated: true,
      cssClass: 'exercise-modal-shell',
      htmlAttributes: { 'aria-label': 'Video: ' + (that.video?.title || '') },
      componentProps: {
        video: that.video,
        exercise: that.exercise,
        reseter: this.reseter,
        basepath: that.api.getMediaBase()
      }
    });

    this.data.setEventsAnalytics('Open Exercise ' + this.exercise.id, 'event', {
      exercise_id: this.exercise.id,
      video_id: this.video ? this.video.id : '',
      level: this.exercise.getCurrentLevel
    });

    return await modal.present();
  }

   thumbpath(){
    if(this.exercise.thumb)
      return encodeURI(this.api.mediaUrl(this.exercise.thumb));
    else
      return encodeURI(this.api.mediaUrl(this.video.thumb));
  }

  displayText(value: any): string {
    const text = value == null ? '' : String(value);
    if (localStorage.getItem('app_language') !== 'cy') {
      return text;
    }

    const trimmed = text.trim();
    if (!trimmed || /^CV:\s*/i.test(trimmed)) {
      return text;
    }

    return this.isLikelyEnglish(trimmed) ? `CV: ${text}` : text;
  }

  private isLikelyEnglish(value: string): boolean {
    const normalized = value.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    if (!normalized) {
      return false;
    }

    if (/[\u00C0-\u024F]/.test(normalized)) {
      return false;
    }

    return /\b(the|and|your|you|for|with|while|daily|exercise|exercises|video|videos|advice|quick|minutes|recovery|self management|introduction|start|begin)\b/i.test(normalized);
  }
}